import { Component, OnInit } from '@angular/core';
import { AccountService, InstoreService } from '@app/_services';
import {Sort} from '@angular/material/sort';
import type { Instore } from '@app/_services/Instore'; // './././_services/Instore';
import { first } from 'rxjs/operators';
import { UntypedFormBuilder, UntypedFormGroup, Validators ,FormControl} from '@angular/forms';
import { OwlOptions } from 'ngx-owl-carousel-o';

@Component({
  selector: 'app-calender',
  templateUrl: './calender.component.html',
  styleUrls: ['./calender.component.css']
})
export class CalenderComponent implements OnInit {

  
  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: false,
    touchDrag: false,
    pullDrag: false,
    dots: false,
    navSpeed: 700,
    navText: ['<span class="fa fa-chevron-left fa-2x"></span>','<span class="fa fa-chevron-right fa-2x"></span>'],
    responsive: {
      0:{
        items:1,
        nav:true
      },
      600:{
          items:3,
          nav:false
      },
      1000:{
          items:5,
          nav:true,
          loop:false
      }

    },
    nav: true
  }


  City: any = ['Option 1', 'Option 2', 'Option 3']
  form: UntypedFormGroup;
  page = 1;
  pageSize = 10;
  submitted = false;
  s_ShowroomID;
  festivalInfo : any;
  s_ShowroomName;
  instoreList: Instore[] =  INSTORE;
  sortedList: Instore[] = [];
  filterString = "";

  selAssetTypeValue = -1;
  selCreativeValue = -1; 
  
  AssetsDataLists;
  CreativeDataLists;
  isLoading = false;
  isShowTab = true;

  selectedRegion :String;
  f_Region_Showroom_list;
  RegionDataLists;
  ShowroomDataLists;
  CampaignLists;
  filter_showroom_CampaignLists;
  filter_tc_CampaignLists;

  private formatMonth = 'MM';

  constructor(private accountService: AccountService, private formBuilder: UntypedFormBuilder, private instoreService: InstoreService) { }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      location: ['', Validators.required], //m
      type: ['', Validators.required], //m
      creative: ['', Validators.required], //m
      size: ['', Validators.required], //m
      particulars: ['', Validators.required]
    });

    this.reloadAssetsLists();
    this.reloadCreativeLists();
    this.reloadRegionLists();
    this.reloadShowroomLists();

    this.loadCampaignData();
  }

  // convenience getter for easy access to form fields
  get f() { return this.form.controls; }

  onSubmit() {
  }

  sortListItems(sort: Sort) {

  }

  selectShowroom(id,name){
    this.s_ShowroomID = id;
    this.s_ShowroomName = name;
    this.loadCampaignData();

  }

  isSingle(startStr, endStr, requiredMonth) {
     console.log(startStr+" "+endStr+" "+startStr.split("-")[1] == endStr.split("-")[1] == requiredMonth);
     return startStr.split("-")[1] == endStr.split("-")[1] == requiredMonth;
  }

  getDay(startStr, endStr, requiredMonth) {
    if(this.isMonth(startStr, requiredMonth)) {
      return startStr.split("-")[2];
    } 
    else if(this.isMonth(endStr, requiredMonth)) {
      return endStr.split("-")[2];
    }
    else {
      return "";
    }
  }

 isMonth(datestr, requiredMonth) {
    return datestr.split("-")[1] == requiredMonth;
 }

 getTDClass(startStr, endStr, requiredMonth) {
  if(startStr.split("-")[1] == requiredMonth) {
      return "td-from-calender";
  } 
  else if(endStr.split("-")[1]  == requiredMonth) {
      return "td-to-calender";
  }
  else {
      return ""
  } 
}

 getDivClass(startStr, endStr, requiredMonth) {
      if((startStr.split("-")[1] == requiredMonth) && (endStr.split("-")[1] == requiredMonth)) {
          return "full-calender";
      } 
      else if(startStr.split("-")[1] == requiredMonth) {
          return "from-calender";
      } 
      else if(endStr.split("-")[1]  == requiredMonth) {
          return "to-calender";
      }
      else {
          return ""
      } 
 }

  loadCampaignData() { 

     this.accountService.getShowroomFestivalLists(this.s_ShowroomID)
      .pipe(first())
        .subscribe(
        (response) => {
          this.isLoading = false;
                  this.CampaignLists = response.result;
                  console.log(response.result)
                  this.filter_showroom_CampaignLists = this.CampaignLists;
                  this.filter_tc_CampaignLists = this.CampaignLists;
                  console.log("CampaignLists List "+ JSON.stringify(this.CampaignLists) );

        },
      (error) => {     
        this.isLoading = false;                               
      }
      );
    // this.instoreService.getAllCampaignLists()
    // .pipe(first())
    //   .subscribe(
    //   (response) => {
    //     //this.isLoading = false;
    //     //this.AssetsDataLists = response.result;
    //     this.CampaignLists = response.result;
    //     console.log(response.result)
    //     this.filter_showroom_CampaignLists = this.CampaignLists;
    //     this.filter_tc_CampaignLists = this.CampaignLists;
    //     console.log("CampaignLists List "+ JSON.stringify(this.CampaignLists) );
    //   },
    // (error) => {     
    //   this.isLoading = false;                               
    // }
    // );
  }

  getInfo(data :any){
    this.festivalInfo = data;
  }

  onRegionClick(id:number,regionName:string){
    this.isShowTab = !this.isShowTab;
    this.selectedRegion = regionName;
    this.f_Region_Showroom_list = this.ShowroomDataLists.filter(s => s.region_id === id);
  }

  onCreativeChange(creativeValue) {
    this.selCreativeValue = parseInt(creativeValue, 10);
    this.filterForModule()
  }

  onAssetTypeChange(assetTypeValue) {
      this.selAssetTypeValue = parseInt(assetTypeValue, 10);
      this.filterForModule()
  }

  onBackClick(){
    this.isShowTab = !this.isShowTab;
  }

  showInstoreData(regionID,regionName,showroomID,showroomName) {
    this.filter_showroom_CampaignLists = this.CampaignLists.filter(s => s.showroom_id === showroomID);
    this.filter_tc_CampaignLists = this.filter_showroom_CampaignLists;
    console.log("---showInstoreData  ----"+this.filter_showroom_CampaignLists.length);
  }

  filterLogicforTC() {
    this.filter_tc_CampaignLists = this.filter_showroom_CampaignLists.filter((item) => {
      var typeCondition = true;
      var creativeCondition = true;
      if(this.selAssetTypeValue > 0) {
        typeCondition = (item.asset_type_id == this.selAssetTypeValue);
      }
      if(this.selCreativeValue > 0) {
        creativeCondition = (item.creative_id == this.selCreativeValue);            
      }
      return typeCondition && creativeCondition;
    });
  }

  filterForModule() {
    this.filterLogicforTC();
  }

  onSearchChange(searchValue: string): void {  

  }

  reloadAssetsLists(){
    this.accountService.getAssetsLists()
    .pipe(first())
      .subscribe(
      (response) => {
        this.isLoading = false;
        this.AssetsDataLists = response.result;
      },
    (error) => {     
      this.isLoading = false;                               
    }
    );
  }
  reloadCreativeLists(){
    this.accountService.getCreativeLists()
    .pipe(first())
      .subscribe(
      (response) => {
        this.isLoading = false;
        this.CreativeDataLists = response.result;
      },
    (error) => {     
      this.isLoading = false;                               
    }
    );
  }

  reloadRegionLists(){
    this.accountService.getRegionsLists()
    .pipe(first())
      .subscribe(
      (response) => {
        this.isLoading = false;
        this.RegionDataLists = response.result;
      },
    (error) => {     
      this.isLoading = false;                               
    }
    );
    
  }
  reloadShowroomLists(){
    this.accountService.getShowroomLists()
    .pipe(first())
      .subscribe(
      (response) => {
        this.isLoading = false;
        this.ShowroomDataLists = response.result;
        this.s_ShowroomID = this.ShowroomDataLists[0].id;
        this.s_ShowroomName = this.ShowroomDataLists[0].name;
        this.loadCampaignData() 
      },
    (error) => {     
      this.isLoading = false;                               
    }
    );
  }

}

const INSTORE: Instore[] = []; 


